import { z } from 'zod';

export const CampaignTitleSchema = z.object({
  title: z.string(),
});
